// One message's record, fetched when someone opens its info view.
import { useQuery } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { commsKeys } from '../queryKeys.js';

export function useMessageReceipts(
  siteId: string | null,
  channelId: string | null,
  messageId: string | null,
) {
  const { fetchMessageReceipts } = useClientApis().comms;
  return useQuery({
    queryKey: commsKeys.receipts(siteId ?? '', channelId ?? '', messageId ?? ''),
    queryFn: ({ signal }) => fetchMessageReceipts(siteId!, channelId!, messageId!, signal),
    enabled: !!siteId && !!channelId && !!messageId,
    staleTime: 60 * 1000,
  });
}
